export function isUserActionsTrackingOff(): boolean {
  const turnOffTracking = localStorage.getItem('pw_off_user_actions_tracking');
  return turnOffTracking !== null && turnOffTracking !== '' && turnOffTracking !== '0' && turnOffTracking !== 'false';
}
